import { supabase } from './supabaseClient';
import { toHttpUrl } from './url';

export async function listVendors() {
  const { data, error } = await supabase.from('vendors').select('*').order('name');
  if (error) throw error;
  return data;
}

// Quick-create used by VendorAutocomplete's inline "add as new vendor" flow
// (Finances, Purchase Orders) — name only.
export async function addVendor(name) {
  const { data, error } = await supabase
    .from('vendors')
    .insert({ name })
    .select()
    .single();
  if (error) throw error;
  return data;
}

// Full create used by the Vendors page's own form.
export async function createVendor(fields) {
  const { data, error } = await supabase.from('vendors').insert(fields).select().single();
  if (error) throw error;
  return data;
}

export async function updateVendor(id, updates) {
  const { data, error } = await supabase
    .from('vendors')
    .update(updates)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function deleteVendor(id) {
  const { error } = await supabase.from('vendors').delete().eq('id', id);
  if (error) throw error;
}

// The vendor website field. Normalisation is shared with reorder-item
// product links — see lib/url.js.
export function vendorWebsiteUrl(value) {
  return toHttpUrl(value);
}
